import { LoginForm } from '@/components/forms/LoginForm'

export default function LoginPage() {
  return <LoginForm />
}

